(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-evidence-gallery]:not([data-gallery-ready])').forEach(root => {
      const buttons = [...root.querySelectorAll('[data-gallery-choice]')];
      const panels = [...root.querySelectorAll('[data-gallery-panel]')];
      const status = root.querySelector('[data-gallery-status]');
      if (!buttons.length || buttons.length !== panels.length || buttons.some(button => !panels.some(panel => panel.id === button.getAttribute('aria-controls')))) return;
      const select = index => {
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        panels.forEach(panel => { panel.hidden = panel.id !== buttons[index].getAttribute('aria-controls'); });
        root.style.setProperty('--gallery-progress', `${index / Math.max(1, buttons.length - 1) * 100}%`);
        if (status) status.textContent = panels.find(panel => !panel.hidden).querySelector('h3')?.textContent.trim() || '';
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(index));
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % buttons.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + buttons.length - 1) % buttons.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = buttons.length - 1;
          else return;
          event.preventDefault();
          select(next);
          buttons[next].focus({ preventScroll: true });
          const switcher = buttons[next].parentElement;
          if (switcher.scrollWidth > switcher.clientWidth) buttons[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        });
      });
      const initial = Math.max(0, buttons.findIndex(button => button.dataset.galleryChoice === root.dataset.galleryInitial));
      select(initial);
      root.dataset.galleryReady = 'true';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
